import React, { Component } from 'react';
import $ from 'jquery';
import 'select2';
import 'select2/dist/css/select2.min.css';

import Utils from '../utils/mci-utils';

/**
 * Searchable Select Component
 *
 * Builds a select element with grouped options from provided options list. 
 * Options are grouped using the Utils.groupBy function in utils/utils.js.
 *
 * Properties passed to it as are follows:
 *
 * @var { groupingKey } [Defines the key in dataset used to group options]
 * @var { optionLabelKey } [Specifies the key used for <option>'s label]
 * @var { optionValueKey } [Specifies key to be used for <option>'s value]
 * @var { hasGroupedOptions } [ Boolean group options into <optgroup> or not]
 *
 * NB: The grouping structure defined in Utils.groupBy() function contains 
 * TWO keys per group; 
 *  {
 *      section: "Section Name", // Fetched as label that is used in <optgroup>
 *      section_items: [] // Array of option objects to be used in <option>
 *  }
 * 
 */
class SearchableSelect extends Component{

    constructor(props){
        super(props);

        this.state = {};
    }

    componentDidMount(){
        var selectors = $(".searchable-select").select2();

        selectors.on("change", (e) => {
            this.props.onChange(e);
            // console.log(e.target.name, e.target.value, e.target.selectedIndex);
        });
    }

    hasOptions(){
        return (typeof this.props.options !== "undefined")
    }

    render(){
        const { groupingKey, optionLabelKey, optionValueKey, options } = this.props;

        return(
            <select 
                className={ this.props.className + " searchable-select" }
                name={ this.props.name }
                ref={ this.props.reference }>
                
                { this.props.children }
                
                {
                    this.hasOptions() ?
                    
                        Utils.groupBy(options, groupingKey).map((group, g_index) => {

                            return <optgroup key={ g_index } label={ group.section }>
                            {
                                group.section_items.map((option, o_index) => {

                                    return(
                                        <option
                                            key={ o_index } 
                                            value={ option[optionValueKey] }
                                            data-category={ option["id"] }
                                            data-import-duty={ option["import_duty"] || 0 }
                                            data-excise-duty={ option["excise_duty"] || 0 }
                                            data-vat={ option["vat_duty"] || 0 }
                                            >
                                            { option[optionLabelKey] }
                                        </option>
                                    )
                                })
                            }
                            </optgroup>
                        })
                    : null
                }
            </select>
        )
    }
}

export default SearchableSelect;


// WEBPACK FOOTER //
// ./src/components/SearchableSelect.jsx